export type Chain =
  | 'ethereum'
  | 'binance-smart-chain'
  | 'polygon'
  | 'avalanche'
  | 'arbitrum'
  | 'optimism'
  | 'solana'
  | 'bitcoin-cash'
  | 'litecoin'
  | 'tron'
  | 'bitcoin';

export enum Chains {
  ETHEREUM = 'ethereum',
  BSC = 'binance-smart-chain',
  POLYGON = 'polygon',
  AVALANCHE = 'avalanche',
  ARBITRUM = 'arbitrum',
  OPTIMISM = 'optimism',
  SOLANA = 'solana',
  BITCOINCASH = 'bitcoin-cash',
  LITECOIN = 'litecoin',
  TRON = 'tron',
  BITCOIN = 'bitcoin',
}
export enum Token {
  ARB = 'arbitrum',
  AVAX = 'avalanche',
  BCH = 'bitcoin-cash',
  BNB = 'bnb',
  BTC = 'btc',
  DAI = 'dai',
  ETH = 'ethereum',
  JUP = 'jup',
  LTC = 'litecoin',
  OP = 'optimism',
  POL = 'polygon',
  SOL = 'solana',
  UNI = 'uni',
  USDC = 'usdc',
  USDT = 'tether',
  USDTe = 'usdt.e',
  USDCe = 'usdc.e',
  WBTC = 'wbtc',
  WETH = 'weth',
  WBNB = 'wbnb',
}

export enum NativeToken {
  ARB = 'ARB',
  AVAX = 'AVAX',
  BCH = 'BCH',
  BNB = 'BNB',
  BTC = 'BTC',
  ETH = 'ETH',
  JUP = 'JUP',
  LTC = 'LTC',
  OPT = 'OPT',
  POL = 'POL',
  SOL = 'SOL',
  TRX = 'TRX',
}

export const ChainToNativeAsset: Record<Chain, string> = {
  ethereum: 'ETH',
  'binance-smart-chain': 'BNB',
  polygon: 'POL',
  avalanche: 'AVAX',
  arbitrum: 'ARB',
  optimism: 'OPT',
  solana: 'SOL',
  'bitcoin-cash': 'BCH',
  litecoin: 'LTC',
  tron: 'TRX',
  bitcoin: 'BTC',
};
